import React from 'react'

const PopIn = props => (
  <svg width={12} height={12} {...props} style={{marginTop: "2px"}}>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h16v16H-2z" />
      <path
        d="M10.667 10.667H1.333V1.333H6V0H1.333C.593 0 0 .6 0 1.333v9.334C0 11.4.593 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V6h-1.333v4.667zM7.84 8.827V7.493H5.447L12 .94 11.06 0 4.507 6.553V4.16H3.173v4.667H7.84z"
        fill="#666"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default PopIn
